import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize, map, Observable } from 'rxjs';
import { AtributeCopiiService } from '../atribute-copii.service';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { AtributeCopiiAddPayload } from '../atribute-copii.interface';
import { GrupAtributeService } from '../../grup-atribute/grup-atribute.service';
import { Generic } from 'src/app/interfaces/generic.interface';
import { notDefaultValidator } from 'src/app/validators/not-default';

@Component({
    selector: 'app-add-atribute-copii',
    templateUrl: './add-atribute-copii.component.html',
    styleUrls: ['./add-atribute-copii.component.scss']
})
export class AddAtributeCopiiComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    grupuriAtribute$!: Observable<Generic[]>;

    filterParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        slug: new FormControl('', [Validators.required]),
        description: new FormControl('', [Validators.required]),
        group_id: new FormControl(-1, [Validators.required, notDefaultValidator('-1')]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddAtributeCopiiComponent>,
        private requestService: AtributeCopiiService,
        private grupAtributeService: GrupAtributeService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() {
        this.loadGrupuriAtributeActive();
    }

    loadGrupuriAtributeActive() {
        this.isLoading = true;
        this.grupuriAtribute$ = this.grupAtributeService
            .getListActive()
            .pipe(
                map((results: any) => [this.filterParameter, ...results]),
                finalize(() => (this.isLoading = false))
            );
    }

    submitForm() {
        this.isLoading = true;

        const { name, slug, description, group_id } = this.form
            .value as AtributeCopiiAddPayload;
        const payload: AtributeCopiiAddPayload = {
            name,
            slug,
            description,
            group_id
        };

        this.requestService
            .storeEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
